import React from "react";
import Select from "react-select";
import { Button } from "bootstrap-4-react/lib/components";
import { accountsManagement, alphabeticKeys, alphabeticKeysReg, featureSubmodulePermission, permissionAssociatedWarehouse, SUBF_SELLER } from '../../constant';
import { toast } from 'react-toastify';
import Input from 'react-phone-number-input/input'
import { checkPermission } from "../../config/utils";
import { useSelector } from "react-redux";
import { fetchAddressFromZipCode } from "../../store/actions";
import PropTypes from "prop-types";

const BasicDetails = (props) => {
    const {
        formData,
        TopUpForm,
        editValue,
        errors,
        companyList,
        warehouseList,
        handleSelectChange,
        handleEditable,
        setaddressModalShow,
        saveData,
        addressDataValue,
        handleDefaultAddress,
        handleDeleteAddress,
        countryList,
        handleChangeAddress,
        handleInputValueTypes,
        stateList,
        dispatch,
        setaddressDataValue,
        handleBlur
    } = props;
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const USSates = useSelector((state) => state.shipment.states);

    const handleSaveAddress = () => {
        if (
            addressDataValue &&
            addressDataValue.length > 0 &&
            addressDataValue[0]?.id > 0
        ) {
            saveData();
        } else {
            toast.error("Please add Address");
        }
    };

    const fetchAddress = async (zipCode, index) => {
        if (zipCode) {
            let responseAddress = await Promise.resolve(dispatch(fetchAddressFromZipCode(zipCode)));
            if (responseAddress?.data?.Status === 200) {
                let address = responseAddress?.data?.Entity;
                if (address?.Country) {
                    const updatedFormData = [...addressDataValue];
                    let selectedCountry = countryList?.filter((country) => country.label === address?.Country)[0]; // NOSONAR
                    updatedFormData[index].country = selectedCountry.label;
                    updatedFormData[index].country_Id = selectedCountry.value;
                    updatedFormData[index].state = address.Country === 'United States' ? USSates.filter((state) => state.StateName === address?.State)[0].StateName : address?.State; // NOSONAR
                    updatedFormData[index].city = address.City || updatedFormData[index].city;
                    setaddressDataValue(updatedFormData);
                }
            }
        }
    }

    return (
        <div className="main_content_table fontFix">
            <div className="main__tile_heading cus-btn-include-sec mt-3 pl-4 pr-4">
                Seller Details
                <div className="top_right_button_container">
                    <>
                        {editValue ? (
                            <>
                                <Button
                                    className="cus-seconday-bg-btn top-btn"
                                    disabled={editValue}
                                >
                                    Add Address
                                </Button>
                                <Button
                                    className="cus-seconday-bg-btn top-btn editableBtn"
                                    onClick={handleEditable}
                                >
                                    Edit
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    className="cus-seconday-bg-btn top-btn"
                                    onClick={() => setaddressModalShow(true)}
                                >
                                    Add Address
                                </Button>
                                <Button
                                    className="cus-seconday-bg-btn"
                                    onClick={() => handleSaveAddress()}
                                >
                                    Save
                                </Button>
                            </>
                        )}
                    </>
                </div>
            </div>
            <>
                <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                    <span className="input-label fnt-wgt">Basic Details:</span>
                </div>
                <div className="row modal_input Edit-Form">
                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                        <span className="input-label fnt-wgt-editmgmt">Seller Name:</span>
                    </div>
                    <div className="col-lg-6 col-sm-12 mobMb-10">
                        <div className={"select_react"}>
                            <input
                                value={formData?.newSellerName}
                                onChange={(e) =>
                                    TopUpForm(e.target.value, "newSellerName")
                                }
                                disabled={editValue}
                                className="form-control availableBalanceInput"
                                type="text"
                                name="newSellerName"
                                onBlur={handleBlur}
                            />
                            <p className="error dialogError">
                                {errors.newSellerName}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row modal_input Edit-Form">
                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                        <span className="input-label fnt-wgt-editmgmt">Seller Code:</span>
                    </div>
                    <div className="col-lg-6 col-sm-12 mobMb-10">
                        <div className={"select_react"}>
                            <input
                                value={formData?.sellerCode}
                                onChange={(e) =>
                                    TopUpForm(e.target.value, "sellerCode")
                                }
                                disabled={editValue}
                                className="form-control availableBalanceInput"
                                type="text"
                                name="sellerCode"
                                onBlur={handleBlur}
                            />
                            <p className="error dialogError">
                                {errors.sellerCode}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row modal_input Edit-Form">
                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                        <span className="input-label fnt-wgt-editmgmt">Seller Keywords:</span>
                    </div>
                    <div className="col-lg-6 col-sm-12 mobMb-10">
                        <div className={"select_react"}>
                            <input
                                value={formData?.keyword}
                                onChange={(e) =>
                                    TopUpForm(e.target.value, "keyword")
                                }
                                disabled={editValue}
                                className="form-control availableBalanceInput"
                                type="text"
                                maxLength={200}
                                name="keyword"
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>
                </div>

                <div className="row modal_input Edit-Form">
                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                        <span className="input-label fnt-wgt-editmgmt">Company:</span>
                    </div>
                    <div className="col-lg-6 col-sm-12 mobMb-10">
                        <div className={"select_react"}>
                            <Select
                                isMulti
                                options={companyList}
                                onChange={(value) => handleSelectChange(value, 'companyIds')}
                                className="activeSellerListInput"
                                isDisabled={editValue}
                                value={formData?.companyIds}
                                classNamePrefix="list"
                            />
                            <p className="error dialogError">
                                {errors.companyIds}
                            </p>
                        </div>
                    </div>
                </div>
            </>
            <div className="row modal_input Edit-Form">
                <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                    <span className="input-label fnt-wgt-editmgmt">STE Code:</span>
                </div>
                <div className="col-lg-6 col-sm-12 mobMb-10">
                    <div className={"select_react"}>
                        <input
                            value={formData?.steCode}
                            onChange={(e) =>
                                TopUpForm(e.target.value, "steCode")
                            }
                            disabled={editValue}
                            className="form-control availableBalanceInput"
                            type="text"
                            name="steCode"
                            onBlur={handleBlur}
                        />
                        <p className="error dialogError">
                            {errors.steCode}
                        </p>
                    </div>
                </div>
            </div>

            <div className="row modal_input Edit-Form">
                <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                    <span className="input-label fnt-wgt-editmgmt">Email Address:</span>
                </div>
                <div className="col-lg-6 col-sm-12 mobMb-10">
                    <div className={"select_react"}>
                        <input
                            value={formData?.email}
                            onChange={(e) =>
                                TopUpForm(e.target.value, "email")
                            }
                            className="form-control availableBalanceInput"
                            type="text"
                            disabled={editValue}
                            name="email"
                            onBlur={handleBlur}
                        />
                        <p className="error dialogError">
                            {errors.email}
                        </p>
                    </div>
                </div>
            </div>

            <div className="row modal_input Edit-Form">
                <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                    <span className="input-label fnt-wgt-editmgmt">Secondary Email Address:</span>
                </div>
                <div className="col-lg-6 col-sm-12 mobMb-10">
                    <div className={"select_react"}>
                        <input
                            value={formData?.secondaryEmailAddress}
                            onChange={(e) =>
                                TopUpForm(e.target.value, "secondaryEmailAddress")
                            }
                            className="form-control availableBalanceInput"
                            type="text"
                            disabled={editValue}
                            name="secondaryEmailAddress"
                            onBlur={handleBlur}
                        />
                        <p className="error dialogError">
                            {errors.secondaryEmailAddress}
                        </p>
                    </div>
                </div>
            </div>
            {checkPermission(accountsManagement, SUBF_SELLER, permissionAssociatedWarehouse, featureSubmodulePermission, employeePermissions) && (
                <div className="row modal_input Edit-Form">
                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit ">
                        <span className="input-label fnt-wgt-editmgmt">Warehouse:</span>
                    </div>
                    <div className="col-lg-6 col-sm-12 mobMb-10">
                        <div className={"select_react"}>
                            <Select
                                isMulti
                                options={warehouseList}
                                onChange={(value) => handleSelectChange(value, 'warehouseIds')}
                                className="activeSellerListInput"
                                classNamePrefix="list"
                                isDisabled={editValue}
                                value={formData.warehouseIds}
                            />
                            <p className="error dialogError">
                                {errors.warehouseIds}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div className="row modal_input Edit-Form">
                <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                    <span className="input-label fnt-wgt-editmgmt">Notes:</span>
                </div>
                <div className="col-lg-6 col-sm-12 mobMb-10">
                    <div className={"select_react"}>
                        <textarea
                            value={formData?.notes}
                            onChange={(e) =>
                                TopUpForm(e.target.value, "notes")
                            }
                            className="form-control availableBalanceInput"
                            rows={2}
                            disabled={editValue}
                            name="notes"
                            onBlur={handleBlur}
                        />
                        <p className="error dialogError">
                            {errors.notes}
                        </p>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                <span className="input-label fnt-wgt">Addresses:</span>
            </div>
            {addressDataValue?.length > 0 &&
                addressDataValue?.map((d, index) => (
                    <>
                        {d?.id !== 0 && (
                            <div className="edit-company-address fontFix">
                                {editValue ? (
                                    <div className="row modal_input Edit-Form-company">
                                        <div className="col-4 formLabel Edit"></div>
                                        <div className="col-lg-8 col-sm-12 mobMb-10 delete-company">
                                            <span className="input-label col-4">
                                                <input
                                                    type="radio"
                                                    id="html"
                                                    checked={d?.isDefault}
                                                    onChange={() =>
                                                        handleDefaultAddress(d?.id)
                                                    }
                                                    name="fav_language"
                                                    disabled={true}
                                                    value="HTML"
                                                />
                                                {" "}
                                                <label
                                                    className="default-add-label"
                                                    htmlFor="html"
                                                >
                                                    Default Address
                                                </label>
                                            </span>

                                            <span className="input-label col-4">
                                                {" "}
                                                <i
                                                    className="fa fa-trash-o"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row modal_input Edit-Form-company">
                                        <div className="col-4 formLabel Edit"></div>
                                        <div className="col-lg-8 col-sm-12 mobMb-10 delete-company">
                                            <span className="input-label col-4">
                                                <input
                                                    type="radio"
                                                    id="html"
                                                    checked={d?.isDefault}
                                                    onChange={
                                                        () =>
                                                            handleDefaultAddress(d?.id)
                                                    }
                                                    name="fav_language"
                                                    disabled={false}
                                                    value="HTML"
                                                />
                                                {" "}
                                                <label
                                                    className="default-add-label"
                                                    htmlFor="html"
                                                >
                                                    Default Address
                                                </label>
                                            </span>

                                            <button
                                                className="input-label col-4 delete-btn sortBtn"
                                                onClick={
                                                    () =>
                                                        handleDeleteAddress(d)
                                                }
                                            >
                                                {" "}
                                                <i
                                                    className="fa fa-trash-o"
                                                    aria-hidden="true"
                                                ></i>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Country:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <Select
                                                options={countryList}
                                                onChange={(value) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "country_Id",
                                                        value.value
                                                    )
                                                }
                                                key={d?.id}
                                                className="activeSellerListInput"
                                                isDisabled={editValue}
                                                defaultValue={{ label: d?.country, value: d?.country_Id }}
                                                classNamePrefix="list"
                                                value={{ label: d?.country, value: d?.country_Id }}
                                            />
                                            {errors[`addressModels_${index}`]?.country_Id && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.country_Id}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Zip Code:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <input
                                                value={d?.zipCode}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "zipCode",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(e, alphabeticKeys)
                                                }
                                                className="form-control availableBalanceInput zipCodeField"
                                                type="text"
                                                disabled={editValue}
                                                pattern="\d{5}(-\d{4})?"
                                                title="Please enter a valid zip code format: xxxxx or xxxxx-xxxx"
                                                onBlur={(e) => fetchAddress(e.target.value, index)}
                                            />
                                            {errors[`addressModels_${index}`]?.zipCode && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.zipCode}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {d?.country_Id === 218 ? (
                                    <div className="row modal_input Edit-Form-company">
                                        <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                            <span className="input-label">
                                                State:
                                            </span>
                                        </div>
                                        <div className="col-lg-8 col-sm-12 mobMb-10">
                                            <Select
                                                //   value={formData?.state}
                                                options={stateList}
                                                onChange={(value) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "state",
                                                        value.label
                                                    )
                                                }
                                                className="activeSellerListInput"
                                                isDisabled={editValue}
                                                value={{ label: d?.state, value: '' }}
                                                classNamePrefix="list"
                                            />
                                            {errors[`addressModels_${index}`]?.state && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.state}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row modal_input Edit-Form-company">
                                        <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                            <span className="input-label">
                                                State:
                                            </span>
                                        </div>
                                        <div className="col-lg-8 col-sm-12 mobMb-10">
                                            <input
                                                value={d?.state}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "state",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(e, alphabeticKeysReg)
                                                }
                                                className="form-control availableBalanceInput addressState"
                                                disabled={editValue}
                                                type="text"
                                            />
                                            {errors[`addressModels_${index}`]?.state && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.state}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">City:</span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <input
                                                value={d?.city}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "city",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(
                                                        e,
                                                        /^[A-Za-z]$/
                                                    )
                                                }
                                                className="form-control availableBalanceInput cityField"
                                                disabled={editValue}
                                                type="text"
                                            />
                                            {errors[`addressModels_${index}`]?.city && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.city}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Phone Number:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <Input
                                                value={d?.phoneNumber}
                                                name="returnphone"
                                                disabled={editValue}
                                                onChange={(e) =>
                                                    handleChangeAddress(index, "phoneNumber", e)
                                                }
                                                className={"form-control availableBalanceInput"}
                                            />
                                            {errors[`addressModels_${index}`]?.phoneNumber && (
                                                <p className="error dalogError countrytype-error">
                                                    {errors[`addressModels_${index}`]?.phoneNumber}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Secondary Phone Number:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <Input
                                                value={d?.secondaryPhoneNumber}
                                                name="returnphone"
                                                disabled={editValue}
                                                onChange={(e) =>
                                                    handleChangeAddress(index, "secondaryPhoneNumber", e)
                                                }
                                                className={"form-control availableBalanceInput"}
                                            />
                                            {errors[`addressModels_${index}`]?.secondaryPhoneNumber && (
                                                <p className="error dalogError countrytype-error">
                                                    {errors[`addressModels_${index}`]?.secondaryPhoneNumber}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Address 1:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <input
                                                value={d?.addressFirst}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "addressFirst",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(
                                                        e,
                                                        /^[a-zA-Z0-9\s-]$/
                                                    )
                                                }
                                                className="form-control availableBalanceInput addressFirst"
                                                disabled={editValue}
                                                type="text"
                                            />
                                            {errors[`addressModels_${index}`]?.addressFirst && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.addressFirst}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Address 2:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <input
                                                value={d?.addressSecond}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "addressSecond",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(
                                                        e,
                                                        /^[a-zA-Z0-9\s-]$/
                                                    )
                                                }
                                                className="form-control availableBalanceInput addressSecond"
                                                disabled={editValue}
                                                type="text"
                                            />
                                            {errors[`addressModels_${index}`]?.addressSecond && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.addressSecond}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row modal_input Edit-Form-company">
                                    <div className="col-lg-4 col-sm-12 mobMb-10 formLabel Edit">
                                        <span className="input-label">
                                            Address 3:
                                        </span>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 mobMb-10">
                                        <div className={"select_react"}>
                                            <input
                                                value={d?.addressThird}
                                                onChange={(e) =>
                                                    handleChangeAddress(
                                                        index,
                                                        "addressThird",
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={(e) =>
                                                    handleInputValueTypes(
                                                        e,
                                                        /^[a-zA-Z0-9\s-]$/
                                                    )
                                                }
                                                className="form-control availableBalanceInput addressLine3"
                                                disabled={editValue}
                                                type="text"
                                            />
                                            {errors[`addressModels_${index}`]?.addressThird && (
                                                <p className="error dalogError">
                                                    {errors[`addressModels_${index}`]?.addressThird}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ))}
        </div>
    );
}

BasicDetails.propTypes = {
    formData: PropTypes.object,
    TopUpForm: PropTypes.func,
    fetchAddress: PropTypes.func,
    editValue: PropTypes.bool,
    errors: PropTypes.object,
    companyList: PropTypes.array,
    warehouseList: PropTypes.array,
    handleSelectChange: PropTypes.func,
    handleEditable: PropTypes.func,
    setaddressModalShow: PropTypes.func,
    saveData: PropTypes.func,
    addressDataValue: PropTypes.array,
    handleDefaultAddress: PropTypes.func,
    handleDeleteAddress: PropTypes.func,
    countryList: PropTypes.array,
    handleChangeAddress: PropTypes.func,
    handleInputValueTypes: PropTypes.func,
    stateList: PropTypes.array,
    dispatch: PropTypes.func,
    setaddressDataValue: PropTypes.func,
    handleBlur: PropTypes.func,
}

export default BasicDetails;